"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52],{

/***/ 60052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ widget_byline; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js + 2 modules
var emotion_element_f0de968e_browser_esm = __webpack_require__(17925);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.esm.js + 2 modules
var emotion_serialize_esm = __webpack_require__(2303);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var emotion_is_prop_valid_esm = __webpack_require__(71068);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var isDevelopment = false;

var testOmitPropsOnStringTag = emotion_is_prop_valid_esm/* default */.Z;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      // eslint-disable-next-line prefer-spread
      styles.push.apply(styles, args);
    } else {
      var templateStringsArr = args[0];

      styles.push(templateStringsArr[0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {

        styles.push(args[i], templateStringsArr[i]);
      }
    }

    var Styled = (0,emotion_element_f0de968e_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = react.useContext(emotion_element_f0de968e_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if (finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;

      if (ref) {
        newProps.ref = ref;
      }

      return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/react.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && isDevelopment) {
          return 'NO_COMPONENT_SELECTOR';
        }

        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      var newStyled = createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      }));
      return newStyled.apply(void 0, styles);
    };

    return Styled;
  };
};



;// CONCATENATED MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js









var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// bind it to avoid mutating the original function
var styled = createStyled.bind(null);
tags.forEach(function (tagName) {
  styled[tagName] = styled(tagName);
});



// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/components/image.js
var components_image = __webpack_require__(84334);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(15072);
// EXTERNAL MODULE: ./src/services/index.js
var services = __webpack_require__(63179);
;// CONCATENATED MODULE: ./src/2.0/widgets/widget-byline.js





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border-left: 6px solid var(--quaternary-color);\n  background: #f4f7ff;\n  margin: 16px auto;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n  transition:\n    box-shadow 0.25s ease,\n    transform 0.25s ease;\n    cursor: pointer;\n\n  .byline-img {\n    width: 72px;\n    height: 72px;\n  }\n\n  &:hover {\n    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);\n    transform: translateY(-2px);\n\n    opacity: 0.7;\n  }\n\n  .card-link {\n    display: block;\n    padding: 20px 20px 20px 22px;\n    text-decoration: none;\n    color: inherit;\n\n    &.no-link {\n      cursor: default;\n      pointer-events: none;\n    }\n  }\n\n  .byline-header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n\n  .avatar-wrapper {\n    position: relative;\n    flex-shrink: 0;\n    width: 72px !important;\n    height: 72px !important;\n    img {\n      display: block !important;\n      width: 72px !important;\n      height: 72px !important;\n      aspect-ratio: 1 / 1 !important;\n      margin: 0 !important;\n      margin-top: 0 !important;\n      max-height: unset !important;\n      max-width: unset !important;\n      border-radius: 50%;\n      object-fit: cover;\n      padding: 2px;\n      border: 2px solid var(--quaternary-color);\n    }\n  }\n\n  .avatar-dot {\n    position: absolute;\n    bottom: 3px;\n    right: 3px;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    border: 2px solid #fff;\n  }\n\n  .byline-info {\n    flex: 1;\n  }\n\n  .byline-name {\n    font-size: 28px;\n    font-weight: 700;\n    margin: 0 0 4px;\n    /* ✅ climatecenter → #4aaf7f / อื่นๆ → primary-color */\n    color: var(--secondary-blue);\n    line-height: 1.3;\n    @media (max-width: 768px) {\n      font-size: 25px;\n    }\n  }\n\n  .byline-position {\n    font-size: 13px;\n    color: #888;\n    margin: 0;\n  }\n\n  .byline-desc {\n    margin-top: 14px;\n    padding-top: 14px;\n    border-top: 1px solid rgba(0, 0, 0, 0.07);\n    font-size: 24px;\n    line-height: 1.75;\n    color: #444;\n    @media (max-width: 768px) {\n      font-size: 24px;\n    }\n    p {\n      margin: 0 0 8px;\n    }\n    p:last-child {\n      margin-bottom: 0;\n    }\n\n    a {\n      color: var(--quaternary-color);\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var WidgetByline = function(param) {
    var data = param.data;
    var DEFAULT_BYLINE = [
        {
            p_name: "กรุงเทพธุรกิจ",
            description: "\n        <p>สื่อเศรษฐกิจ ที่อยู่กับการเปลี่ยนแปลงของประเทศมาอย่างยาวนาน</p>\n        <p>ถ่ายทอดข้อมูลที่แม่นยำ รอบด้าน เพื่อให้ผู้บริหาร นักลงทุน ผู้ประกอบการ</p>\n        <p>ตัดสินใจบนพื้นฐานของ “ข้อเท็จจริง” และ “โอกาส”</p>\n      ",
            image: "/images/default.jpg"
        }
    ];
    var ref = (0,react.useState)(function() {
        return (data === null || data === void 0 ? void 0 : data.length) > 0 ? data : DEFAULT_BYLINE;
    }), bylineData = ref[0], setBylineData = ref[1];
    (0,react.useEffect)(function() {
        if (!isEmpty_default()(data)) {
            setBylineData(data);
            return;
        }
        var active = true;
        (0,_async_to_generator/* default */.Z)(function() {
            var res, byline, _tmp, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,services/* GET */.H)("/api/v1.0/bylines/contents/".concat(encodeURIComponent("กรุงเทพธุรกิจ")), false, true)
                        ];
                    case 1:
                        res = _state.sent();
                        if (!active) return [
                            2
                        ];
                        byline = res === null || res === void 0 ? void 0 : res.byline;
                        _tmp = {};
                        if (!isEmpty_default()(byline)) {
                            setBylineData([
                                (_tmp.p_name = byline.p_name, _tmp.description = byline.description, _tmp.image = byline.image, _tmp)
                            ]);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        if (!active) return [
                            2
                        ];
                        // keep default placeholder if fetch fails
                        setBylineData(DEFAULT_BYLINE);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            active = false;
        };
    }, [
        data
    ]);
    if (isEmpty_default()(bylineData)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetWrapper, {
        className: "byline-body",
        style: {
            filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : "unset"
        },
        children: bylineData.map(function(item, index) {
            var hasLink = !isEmpty_default()(item === null || item === void 0 ? void 0 : item.p_name);
            var CardTag = hasLink ? "a" : "div";
            var href = hasLink ? "/bylines/".concat(String(item.p_name).split("/").map(encodeURIComponent).join("/")) : undefined;
            var linkProps = hasLink ? {
                href: href,
                "aria-label": "ดูบทความของ ".concat(item.p_name)
            } : {};
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, linkProps), {
                        className: "card-link ".concat(hasLink ? "" : "no-link"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "byline-header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "avatar-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image["default"], {
                                            type: "CARD_SMALL",
                                            width: "72px",
                                            height: "72px",
                                            className: "byline-img",
                                            image: (item === null || item === void 0 ? void 0 : item.image) || "/images/default.jpg",
                                            title: item === null || item === void 0 ? void 0 : item.p_name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "byline-info",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "byline-name",
                                                children: item === null || item === void 0 ? void 0 : item.p_name
                                            }),
                                            (item === null || item === void 0 ? void 0 : item.position) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "byline-position",
                                                children: item.position
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isEmpty_default()(item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "byline-desc",
                                dangerouslySetInnerHTML: {
                                    __html: item.description
                                }
                            })
                        ]
                    }))
                })
            }, index);
        })
    });
};
/* ------------------------------------------------------------------ */ /*  Styled Components                                                   */ /* ------------------------------------------------------------------ */ var CardWrapper = styled.div(_templateObject());
var WidgetWrapper = styled.div(_templateObject1());
/* harmony default export */ var widget_byline = (WidgetByline);


/***/ })

}]);